import React, { useState } from 'react'

import { Stack, Typography } from '@mui/material'

import { Modal, Button, TextArea } from '@repo/ui'

/**
 * Modal that appears when a user clicks "Upvote" on an integration request (VERA-407).
 * Captures an optional "why" reason before recording the vote.
 */
export const VoteReasonModal = ({
  open,
  integrationName,
  onSubmit,
  onClose,
}: {
  open: boolean
  integrationName: string
  onSubmit: (reason: string) => void
  onClose: () => void
}) => {
  const [reason, setReason] = useState('')

  const handleClose = () => {
    setReason('')
    onClose()
  }

  const handleSubmit = () => {
    onSubmit(reason.trim())
    setReason('')
  }

  return (
    <Modal
      title={`Upvote ${integrationName}`}
      open={open}
      onClose={handleClose}
      actions={
        <>
          <Button disableElevation variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" disableElevation onClick={handleSubmit}>
            Submit vote
          </Button>
        </>
      }
    >
      <Stack spacing={3}>
        <Typography variant="body1" color="text.secondary" sx={{ fontSize: '14px', lineHeight: 1.5 }}>
          Your vote helps us prioritize which integrations to build next.
        </Typography>

        <Stack spacing={1}>
          <Typography variant="body3">Why do you want this? (optional)</Typography>
          <TextArea
            minRows={3}
            placeholder="Please tell us why you want this integration"
            value={reason}
            onChange={(v) => setReason(v)}
          />
        </Stack>
      </Stack>
    </Modal>
  )
}
